import { render, staticRenderFns } from "./pg-userInfo.vue?vue&type=template&id=7e2adbc6&scoped=true"
import script from "./pg-userInfo.vue?vue&type=script&lang=js"
export * from "./pg-userInfo.vue?vue&type=script&lang=js"
import style0 from "./pg-userInfo.vue?vue&type=style&index=0&id=7e2adbc6&prod&lang=css"
import style1 from "./pg-userInfo.vue?vue&type=style&index=1&id=7e2adbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2adbc6",
  null
  
)

export default component.exports